import React, {Component} from "react";
import {Route, Switch, withRouter} from "react-router-dom";
import {connect} from 'react-redux';
import Loadable from "react-loadable";
import Nav from "./components/common/nav/Nav";
import Slider from "./components/slider/Slider";
import Loading from "./components/common/Loading";
import Footer from "./components/common/footer/Footer";
import PartnerForm from "./components/homePage/partnerStories/PartnerForm";
import PartnerStory from "./components/partnerStory/PartnerStory";
import Subscription from "./components/subscription/Subscription";
import PrivacyPolicy from"./components/privacyPolicy/PrivacyPolicy";
import Search from "./components/common/Search";
import PartnerStoryList  from './components/partnerStory/PartnerStoryList'
import Preloader from "./components/common/Preloader";
import CookieConsent from "react-cookie-consent";
import {frontendUrl} from './utils/globals';
import $ from 'jquery';

const About = Loadable({
    loader: () => import("./components/about/About"),
    loading: Loading
});

const Contact = Loadable({
    loader: () => import("./components/contact/Contact"),
    loading: Loading
});

const District = Loadable({
    loader: () => import("./components/district/District"),
    loading: Loading
});

const Faq = Loadable({
    loader: () => import("./components/faq/Faq"),
    loading: Loading
});

const GalleryPage = Loadable({
    loader: () => import("./components/galleryPage/GalleryPage"),
    loading: Loading
});

const GalleryDetail = Loadable({
    loader: () => import("./components/galleryPage/galleryDetail/GalleryDetail"),
    loading: Loading
});

const Home = Loadable({
    loader: () => import("./components/homePage/Home"),
    loading: Loading
});

const HrrpReferenceLibrary = Loadable({
    loader: () =>
        import("./components/hrrpReferenceLibrary/HrrpReferenceLibrary"),
    loading: Loading
});
const MapsInfographics = Loadable({
    loader: () => import("./components/mapsInfographics/MapsInfographics"),
    loading: Loading
});

const NewsEvent = Loadable({
    loader: () => import("./components/newsEvent/NewsEvent"),
    loading: Loading
});

// const PrivacyPolicy = Loadable({
//     loader: () => import("./components/privacyPolicy/PrivacyPolicy"),
//     loading: Loading
// });

const NewsEventsDetail = Loadable({
    loader: () => import("./components/newsEventsDetail/NewsEventsDetail"),
    loading: Loading
});

const RecentMinutes = Loadable({
    loader: () => import("./components/recentMinutes/RecentMinutes"),
    loading: Loading
});
const MeetingDetail = Loadable({
    loader: () => import("./components/recentMinutes/DetailPage"),
    loading: Loading
});
const FourError = Loadable({
    loader: () => import("./components/error/FourError"),
    loading: Loading
});
const FiveError = Loadable({
    loader: () => import("./components/error/FiveError"),
    loading: Loading
});

class App extends Component {

    assembleView() {
        let path = this.props.location.pathname;
        let {showPreloader} = this.props;

        if(showPreloader && showPreloader.show === true){
            $('body').addClass('loading')
        }   else    {
            $('body').removeClass('loading')
        }

        return (
            <React.Fragment>

                {showPreloader && showPreloader.show === true && <Preloader/>}

                <header className="header">
                    <Nav addClass={path !== "/" ? "scrolled" : ""}/>
                    {path === "/" && <Slider/>}
                </header>

                <div id="content" className={path === "/" ? "no-margin" : ""}>
                    <Switch>
                        <Route exact path="/" component={Home}/>
                        <Route exact path="/about" component={About}/>
                        <Route exact path="/faq" component={Faq}/>
                        <Route exact path="/contact" component={Contact}/>
                        <Route exact path="/district/:id" component={District}/>
                        <Route exact path="/news-events-detail/:id" component={NewsEventsDetail}/>
                        <Route exact path="/news-events" component={NewsEvent}/>
                        <Route
                            exact
                            path="/hrrp-reference-library/:category?"
                            component={HrrpReferenceLibrary}
                        />
                        <Route
                            exact
                            path="/maps-infographics/:category?"
                            component={MapsInfographics}
                        />
                        <Route
                            exact
                            path="/maps/:category?"
                            component={MapsInfographics}
                        />
                        <Route
                            exact
                            path="/infographics/:category?"
                            component={MapsInfographics}
                        />
                        <Route
                            exact
                            path="/maps/district/:district"
                            component={MapsInfographics}
                        />
                        <Route
                            exact
                            path="/infographics/district/:district"
                            component={MapsInfographics}
                        />
                        <Route
                            exact
                            path="/maps-infographics/district/:district"
                            component={MapsInfographics}
                        />
                        <Route exact path="/recent-minutes/:id?" component={RecentMinutes}/>
                        <Route exact path="/recent-minutes/district/:district" component={RecentMinutes}/>
                        <Route exact path="/meeting-detail/:id" component={MeetingDetail}/>
                        <Route exact path="/gallery-page" component={GalleryPage}/>
                        <Route exact path="/gallery/:id" component={GalleryDetail}/>
                        <Route exact path="/partner-form" component={PartnerForm}/>
                        <Route exact path="/search" component={Search}/>
                        <Route exact path="/partner-stories" component={PartnerStoryList}/>
                        <Route exact path="/partner-story/:id" component={PartnerStory}/>
                        <Route exact path="/subscription" component={Subscription}/>
                        <Route exact path="/privacy" component={PrivacyPolicy}/>

                        
                        <Route exact path="/404" component={FourError}/>
                        <Route exact path="/500" component={FiveError}/>
                        <Route component={FourError}/>
                    </Switch>
                    <Footer/>
                </div>
                <div id="cookiePolicy">
                       <CookieConsent
                        enableDeclineButton
                        location="bottom"
                        buttonText="OK, I agree"
                        declineButtonText="No, thanks "
                        // cookieName="myAwesomeCookieName2"
                        // style={{ background: "#ddd" }}
                        // buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                        expires={150}
                       >This website uses cookies to enhance the user experience.
                       <button style={{
                           height:'34px',
                           paddingLeft:'5px',
                           paddingRight: '5px',
                           marginLeft: '2%', 
                        }}>
                        <a href={`${frontendUrl}/privacy`}
                       target="_blank"
                       >More info</a></button>
                       </CookieConsent>
                </div>
            </React.Fragment>
        );
    }

    render() {
        return this.assembleView();
    }
}

const mapStateToProps = state => {
    return {
        showPreloader: state.showPreloader
    }
}

export default withRouter(
    connect(mapStateToProps)(App)
);
